//import constanteApi from "@/conf-global.js";
export default {
    capitalizeWords: function (arr) {
        return arr.map(element => {
            return element.charAt(0).toUpperCase() + element.substring(1).toLowerCase();
        });
    },

    makeReadable: function (key) {
        return this.capitalizeWords(key.replaceAll('_', ' ').split(' ')).join(' ');
    },
    getConstantes: () => {
        try {
            axios.get('/constante/global').then((r) => {
                //console.log(r.data.constantes)
                return r.data.constantes
            }).catch((e) => {
              console.log(e)
            })
            
        } catch (error) {
              console.log('Error al consultar constantes', error)
              throw error
        }
    },
    currencySymbol: (code = '') => {
        let symbol = ''
        if (code == 'PEN') {
            symbol = 'S/'
        } else if (code == 'USD') {
            symbol = '$'
        } else if (code == 'EUR') {
            symbol = '€'
        }
        return symbol
    },
    unensRound: (num = 0, decimal = 2) => {
        return Math.round((num + Number.EPSILON) * 100) / 100
    },
    isEmpty: (data) => {
        return (data == null || data == "" || (Array.isArray(data) && data.length === 0) || (data.constructor === Object && Object.keys(data).length === 0) || typeof data === 'undefined')
    },
    number2WhatsApp: (number) => {
        let nw = number
        if (number) {
            let pos = number.indexOf("+")
            if (pos !== 0) {
                nw = '+51' + number // Si no tiene + es porque sólo pusieron número ej 987 654 321
            }
        }
        return nw
    },
    number2Phone: (number, type = '') => {
        let nview = ''
        if (number) {
            let pos1 = ''
            let pos2 = ''
            let pos3 = ''
            let pos4 = ''
            if (type== 'celular') {
                if (number.length == 12) {
                    pos1 = number.substring(0, 3)
                    pos2 = number.substring(3, 6)
                    pos3 = number.substring(6, 9)
                    pos4 = number.substring(9, 12)
                    nview = '(' + pos1 + ') ' + pos2 + ' ' + pos3 + ' ' + pos4 // Formatear para la vista de teléfono celular
                } else {
                    pos1 = '+51'
                    pos2 = number.substring(0, 3)
                    pos3 = number.substring(3, 6)
                    pos4 = number.substring(6, 9)
                    nview = '(' + pos1 + ') ' + pos2 + ' ' + pos3 + ' ' + pos4 // Formatear para la vista de teléfono celular
                }
                
            } else if (type== 'fijo') {
                if (number.length == 9) {
                    pos1 = number.substring(0, 2)
                    pos2 = number.substring(2, 5)
                    pos3 = number.substring(5, 9)
                    nview = '(' + pos1 + ') ' + pos2 + ' ' + pos3// Formatear para la vista de teléfono fijo
                } else {
                    pos1 = number.substring(0, 3) // 054 eb caso de arequipa son 10 dígitos
                    pos2 = number.substring(3, 6)
                    pos3 = number.substring(6, 10)
                    nview = '(' + pos1 + ') ' + pos2 + ' ' + pos3// Formatear para la vista de teléfono fijo
                }
            }     
            
        }
        return nview
    }
}